import ArrowLeftIcon from "@/assets/icons/arrow_left.svg";
import ArrowRightIcon from "@/assets/icons/arrow_right.svg";
import BinDropIcon from "@/assets/icons/bindropicon.svg";
import CheckCircleIcon from "@/assets/icons/check_circle.svg";
import CheckMarkIcon from "@/assets/icons/check_mark.svg";
import ChevronDownIcon from "@/assets/icons/chevron_down.svg";
import ChevronLeftIcon from "@/assets/icons/chevron_left.svg";
import ChevronRightIcon from "@/assets/icons/chevron_right.svg";
import ChevronUpDownIcon from "@/assets/icons/chevron_up_down.svg";
import ChevronUpIcon from "@/assets/icons/chevron_up.svg";
import CloseIcon from "@/assets/icons/close.svg";
import DragDropIcon from "@/assets/icons/dragdrop.svg";
import ExclamationCircleIcon from "@/assets/icons/exclamation_circle.svg";
import HouseIcon from "@/assets/icons/house.svg";
import JunkSosIcon from "@/assets/icons/junksos.svg";
import LocationMarkUnderscoredIcon from "@/assets/icons/location_mark_underscored.svg";
import LocationMarkIcon from "@/assets/icons/location_mark.svg";
import MenuIcon from "@/assets/icons/menu.svg";
import NotesIcon from "@/assets/icons/notes.svg";
import PencilIcon from "@/assets/icons/pencil.svg";
import PhoneIcon from "@/assets/icons/phone.svg";
import PlusIcon from "@/assets/icons/plus.svg";
import RoundedExclamationMarkIcon from "@/assets/icons/rounded_exclamation_mark.svg";
import SearchIcon from "@/assets/icons/search.svg";
import SpikeLogoIcon from "@/assets/icons/spike_logo.svg";
import StarSelectedIcon from "@/assets/icons/star_selected.svg";
import StartUnselectedIcon from "@/assets/icons/star_unselected.svg";
import TruckIcon from "@/assets/icons/truck.svg";

export const iconRegistry = {
  ArrowRight: ArrowRightIcon,
  ArrowLeft: ArrowLeftIcon,
  Plus: PlusIcon,
  Phone: PhoneIcon,
  Menu: MenuIcon,
  Notes: NotesIcon,
  Pencil: PencilIcon,
  Search: SearchIcon,
  Close: CloseIcon,
  DragDrop: DragDropIcon,
  LocationMarkUnderscored: LocationMarkUnderscoredIcon,
  House: HouseIcon,
  LocationMark: LocationMarkIcon,
  ChevronLeft: ChevronLeftIcon,
  ChevronRight: ChevronRightIcon,
  ChevronUpDown: ChevronUpDownIcon,
  ChevronUp: ChevronUpIcon,
  ChevronDown: ChevronDownIcon,
  StarSelected: StarSelectedIcon,
  StartUnselected: StartUnselectedIcon,
  Truck: TruckIcon,
  RoundedExclamationMark: RoundedExclamationMarkIcon,
  CheckCircle: CheckCircleIcon,
  CheckMark: CheckMarkIcon,
  ExclamationCircle: ExclamationCircleIcon,
  BinDrop: BinDropIcon,
  JunkSos: JunkSosIcon,
  SpikeLogo: SpikeLogoIcon,
};

export type IconType = keyof typeof iconRegistry;
